import React, { forwardRef, useRef, useState } from 'react'
import DataService from '../../services/data.service';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const Content = () => {
    const [loading, setLoading] = useState("");
    const [successOpen, setSuccessOpen] = useState(false);
    const [failOpen, setFailOpen] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [file, setFile] = useState(null);
    let inputRef = useRef(null);
    const formType = 'contact';

    const handleClose = (event, reason) => {
        setSuccessOpen(false);
        setFailOpen(false);
    };

    const fileSelectHandler = (e) => {
        setFile(e.target.files[0]);
        console.log(file);
    }

    const sendtomail = (e) => {
        e.preventDefault();
        setLoading(true);

        const data = new FormData();
        data.append('name', name);
        data.append('email', email);
        data.append('phone', phone);
        data.append('subject', subject);
        data.append('message', message);
        data.append('formType', formType);

        DataService.sendMail(data)
            .then((response) => {
                if (response.message === 'success') {
                    setSuccessOpen(true);
                    setLoading(false);
                }
                else {
                    setFailOpen(true);
                    setLoading(false);
                }
                setName("");
                setEmail("");
                setPhone("");
                setSubject("");
                setMessage("");
            })
    }

    return (
        <div>
            <Snackbar open={successOpen} autoHideDuration={10000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                    This is a success message!
                </Alert>
            </Snackbar>
            <Snackbar open={failOpen} autoHideDuration={10000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }} >
                    This is a warning message!
                </Alert>
            </Snackbar>
            <div id="contact" class="contact-us section">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 offset-lg-3">
                            <div class="section-heading wow fadeIn" data-wow-duration="1s" data-wow-delay="0.5s">
                                <h6>Contact Us</h6>
                                <h4>Get In Touch With Us <em>Now</em></h4>
                                <div class="line-dec"></div>
                            </div>
                        </div>
                        <div class="col-lg-12 wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.25s">
                            <form id="contact" onSubmit={sendtomail}>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="contact-dec">
                                            <img src="assets/images/contact-dec.png" alt="Frishtey Media" />
                                        </div>
                                    </div>
                                    {/*<div class="col-lg-5">
                                        <div id="map">
                                            <iframe src="https://www.google.com/maps/place/Bathinda,+Punjab/@30.2087515,74.8886466,12z/data=!3m1!4b1!4m5!3m4!1s0x39173297173abbcd:0xa00033c0a58a5ac8!8m2!3d30.210994!4d74.9454745" width="100%" height="636px" frameborder="0" style="border:0" allowfullscreen></iframe>
                                        </div>
                                    </div>*/}
                                    <div class="col-lg-12">
                                        <div class="fill-form">
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <div class="info-post">
                                                        <div class="icon">
                                                            <img src="assets/images/phone-icon.png" alt="Frishtey Media" />
                                                            <a href="tel:9530688807">+91 9530688807</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="info-post">
                                                        <div class="icon">
                                                            <img src="assets/images/email-icon.png" alt="Frishtey Media" />
                                                            <a href="mailto:info@frishtey.com">info@frishtey.com</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="info-post">
                                                        <div class="icon">
                                                            <img src="assets/images/location-icon.png" alt="Frishtey Media" />
                                                            <a href="/">1st Floor,Power House Road Chowk, Bathinda, Punjab. </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <fieldset>
                                                        <input type="name" name="name" id="name" placeholder="Name" autocomplete="on" required
                                                            value={name} onChange={e => setName(e.target.value)} />
                                                    </fieldset>
                                                    <fieldset>
                                                        <input type="text" name="email" id="email" pattern="[^ @]*@[^ @]*" placeholder="Your Email" required
                                                            value={email} onChange={e => setEmail(e.target.value)} />
                                                    </fieldset>
                                                    <fieldset>
                                                        <input type="text" name="phone" id="phone" placeholder="Mobile Number" autocomplete="on" required
                                                            value={phone} onChange={e => setPhone(e.target.value)} />
                                                    </fieldset>
                                                    <fieldset>
                                                        <input type="subject" name="subject" id="subject" placeholder="Subject" autocomplete="on"
                                                            value={subject} onChange={e => setSubject(e.target.value)} />
                                                    </fieldset>
                                                </div>
                                                <div class="col-lg-6">
                                                    <fieldset>
                                                        <textarea name="message" type="text" class="form-control" id="message" placeholder="Message" required
                                                            value={message} onChange={e => setMessage(e.target.value)}></textarea>
                                                    </fieldset>
                                                    <fieldset>
                                                        <input name="file" type="file" class="form-control" id="file" onChange={fileSelectHandler} ref={inputRef} />
                                                    </fieldset>
                                                </div>
                                                <div class="col-lg-12">
                                                    <fieldset>
                                                        {
                                                            loading ?
                                                                <button type="submit" class="main-button" disabled>
                                                                    <span className="spinner-border spinner-border-sm"></span>&nbsp;
                                                                    Loading...
                                                                </button>
                                                                :
                                                                <button type="submit" class="main-button">
                                                                    Send Message Now
                                                                </button>
                                                        }
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
